import { render, staticRenderFns } from "./Blocks.vue?vue&type=template&id=2ae8c96e&"
import script from "./Blocks.vue?vue&type=script&lang=ts&"
export * from "./Blocks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports